var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "custom-navbar-logo-container" },
    [
      !_vm.seasonLogoUrl
        ? _c("VIcon", {
            staticClass: "custom-navbar-logo",
            class: { theme: _vm.useThemeColor },
            attrs: { icon: "logo" },
          })
        : _c("div", {
            staticClass: "custom-navbar-logo season",
            style: { backgroundImage: `url(${_vm.seasonLogoUrl})` },
          }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }